import RazorpayMethod from './razorpay-method';

export default RazorpayMethod;
